// Запасные подписи вкладок панели (сервер не прислал label) — Р-3. Отдельно от экрана «Скоро»: их берёт оболочка в
// первом куске, а «Скоро» и заглушки экранов грузятся лениво.
import { t, type StringKey } from '../../i18n/i18n';

const TAB_LABEL: Record<string, StringKey> = {
  matches: 'shell.tab.matches', leagues: 'shell.tab.leagues', favorites: 'shell.tab.favorites', news: 'shell.tab.news',
  highlights: 'shell.tab.highlights',
};
/** Запасная подпись вкладки (сервер не прислал label) — Р-3. */
export const tabFallbackLabel = (key: string) => (TAB_LABEL[key] ? t(TAB_LABEL[key]!) : key);
